import type { Chain } from "@suse-o11y/chain";
import type { Defaultable } from "@suse-o11y/defaultable";
import type { Functor } from "@suse-o11y/functor";
import { Matchable } from "@suse-o11y/matchable";

class Idle extends Matchable<"idle"> implements Functor<never>, Chain<never>, Defaultable<never> {
	protected readonly __name = "idle" as const;

	public isIdle(): this is Idle {
		return true;
	}

	public isLoading(): false {
		return false;
	}

	public isFailure(): false {
		return false;
	}

	public isSuccess(): false {
		return false;
	}

	public getOrElse<TFallback>(fallback: TFallback): TFallback {
		return fallback;
	}

	public transform(): this {
		return this;
	}

	public transformFailure(): this {
		return this;
	}

	public chain(): this {
		return this;
	}
}

export { Idle };
